import { useMemo } from 'react';
import { useDashboardConfig } from '@trinity/chat-components/containers/Dashboard/context';
import type { CategoryGroup } from '@trinity/chart-theming';

/**
 * Returns a `CategoryGroup[]` shaped for `ChartThemePicker` from the custom
 * themes stored in `DashboardConfig.customThemes`.
 *
 * Produces a single category (`id: 1, name: 'Themes'`) so the picker renders
 * all user-created palettes under one group.
 */
export function useDashboardThemeCategories(selectedThemeId: number | null): CategoryGroup[] {
  const { config } = useDashboardConfig();

  return useMemo<CategoryGroup[]>(() => {
    const items = (config.customThemes ?? []).map(t => ({
      id: t.id,
      name: t.name,
      colors: t.colors,
      editable: false, // delete/edit can be added later
    }));

    return [
      {
        category: { id: 1, name: 'Themes' },
        items,
        paletteId: selectedThemeId ?? 0,
      },
    ];
  }, [config.customThemes, selectedThemeId]);
}
